import config from '../../config'
import {
  HTTP
} from '../../http'
const pageSize = 15
export default {
  findAll: (keywords, primaryKey, page) => {
    return new Promise((resolve, reject) => {
      const model = {
        "searchOptions": {
          "primaryKey": primaryKey,
          "pageIndex": page,
          "pageSize": pageSize,
          "keywords": keywords
        }
      }
      HTTP.post(config.apiEndpoints.auditingUri.concat('find'), model).then((response) => {
        resolve(response)
      }, (error) => {
        reject(error)
      })
    })
  }
}
